/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';
import SimpleInput from '/client/src/components/forms/simpleInput';
import ReactSummernote from 'react-summernote';
import { SummenrNoteToolbar, SummenrNoteToolbarHeight10Lines } from '/client/src/constants/';
import TicketDates from './dates';
import SimpleSelect from '/client/src/components/forms/select';
import FeeTooltip from '../feeTooltip';
import _ from 'lodash';
import { currency } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { getWordsCount } from '/client/src/utils/string';
import { convertToUTC } from '../../../../../utils/jstz';

type PropsType = {
  index: number,
  tickets: [],
  ticket?: {
    description?: string,
    short_description?: any,
    specific_message: any,
    default_ticket_quantity: any,
    order_min_quantity: any,
    order_max_quantity: any,
    price: any,
    tax: any,
    fee_type: any,
    is_need_code_to_show: any,
    is_set_sale_time: any,
    sale_begin_time_utc: any,
    sale_end_time_utc: any,
    stock_quantity: any,
    is_mark_ticket_level_as_sold_out?: boolean,
    is_hide_ticket_level_from_pos?: boolean,
    show_is_sould_out_ticket_id?: number | string,
    is_show_ticket_description: boolean,
    is_show_long_ticket_description: boolean,
    is_add_ticket_custom_confirmation: boolean,
    is_customize_ticket_quantity_options: boolean,
    is_customize_ticket_taxes_and_fees: boolean
  },
  setValidateDataLength: () => void,
  singleTicketObjIndex: string | number,
  onHandleControlTicketData: (any) => void,
  __setTax: () => void,
  __setMerchantFee: () => void,
  __setPercantage: () => void,
  __setUsePercantage: () => void,
  __setMoneyTax: () => void,
  __setFeeTypeExclude: () => void,
  feeTypeExclude: boolean,
  price?: *,
  tax?: *,
  percentage?: *,
  moneyTax?: *,
  use_percentage?: *
};

const EventDetailsTicketAdvSet = (props: PropsType): React.Element<> => {
  const context = React.useContext(DefaultContainerContext);
  const eventContext = React.useContext(EventDetailContainerContext);
  const _ticket = props.ticket;
  const ticketId = _.get(_ticket, 'id', 0);
  const [short_description, _setShortDescription] = React.useState(_.get(_ticket, 'short_description'));
  const [description, _setLong_description] = React.useState(_.get(_ticket, 'description'));
  const [specific_message, _setSpecific_message] = React.useState(_.get(_ticket, 'specific_message'));
  const [order_min_quantity, _setOrderMinQuantity] = React.useState(_.get(_ticket, 'order_min_quantity'));
  const [order_max_quantity, _setOrderMaxQuantity] = React.useState(_.get(_ticket, 'order_max_quantity'));
  const [merchant_fee, _setMerchant_fee] = React.useState(_.get(_ticket, 'merchant_fee'));
  const [is_need_code_to_show, _setIsNeedCodeToShow] = React.useState(_.get(_ticket, 'is_need_code_to_show'));
  const [is_set_sale_time, _setIsSetSaleTime] = React.useState(_.get(_ticket, 'is_set_sale_time'));
  const [is_show_ticket_description, ShowTicketDescr] = React.useState(_.get(_ticket, 'is_show_ticket_description'));
  const [is_show_long_ticket_description, ShowLongTicketDescr] = React.useState(_.get(_ticket, 'is_show_long_ticket_description'));
  const [
    default_ticket_quantity,
    _setDefaultTicketQuantity
  ] = React.useState(_.get(_ticket, 'default_ticket_quantity'));
  const [
    is_add_ticket_custom_confirmation,
    ShowConfigMsg
  ] = React.useState(_.get(_ticket, 'is_add_ticket_custom_confirmation'));
  const [
    is_customize_ticket_quantity_options,
    ShowTicketQuantity
  ] = React.useState(_.get(_ticket, 'is_customize_ticket_quantity_options'));
  const [
    is_customize_ticket_taxes_and_fees,
    ShowTaxes
  ] = React.useState(_.get(_ticket, 'is_customize_ticket_taxes_and_fees'));
  const [
    sale_begin_time_utc,
    _setSale_begin_time_utc
] = React.useState(_.get(_ticket, 'sale_begin_time_utc', _.get(eventContext, 'eventDetail.begin_time_utc', convertToUTC(Date.now(), eventContext.time_zone_id))));
  const [
    sale_end_time_utc,
    _setSale_end_time_utc
  ] = React.useState(_.get(_ticket, 'sale_end_time_utc', _.get(eventContext, 'eventDetail.end_time_utc', convertToUTC(Date.now(), eventContext.time_zone_id))));
  const [
    show_is_sould_out_ticket_id,
    _setShow_is_sould_out_ticket_id
  ] = React.useState(_.get(_ticket, 'show_is_sould_out_ticket_id', null));
  const [
    show_is_sould_out_ticket_id_switcher,
    _setShow_is_sould_out_ticket_id_switcher
  ] = React.useState(!!_.get(_ticket, 'show_is_sould_out_ticket_id', false));
  const [
    is_mark_ticket_level_as_sold_out,
    _setIs_mark_ticket_level_as_sold_out
  ] = React.useState(!!_.get(_ticket, 'is_mark_ticket_level_as_sold_out', false));
  const [
    is_hide_ticket_level_from_pos,
    _setIs_hide_ticket_level_from_pos
  ] = React.useState(!!_.get(_ticket, 'is_hide_ticket_level_from_pos', false));

  const {
    index,
    singleTicketObjIndex,
    tickets,
    feeTypeExclude,
    onHandleControlTicketData,
    __setUsePercantage,
    __setFeeTypeExclude,
    setValidateDataLength
  } = props;

  const setFeeType = (status: boolean) => {
    __setFeeTypeExclude(status);
    if (!status) {
      ShowTaxes(true);
    }
  };
  const handleChangeMCE = (content: string) => {
    _setSpecific_message(content);
  };

  const handleChangeDate = (date: string, field: string) => {
    if (field === 'sale_begin_time_utc') {
      _setSale_begin_time_utc(date);
    } else {
      _setSale_end_time_utc(date);
    }
  };

  React.useMemo(() => {
    const _tickets = tickets;

    _tickets[singleTicketObjIndex] = {
      ..._tickets[singleTicketObjIndex],
      short_description,
      description,
      specific_message,
      order_min_quantity,
      order_max_quantity,
      default_ticket_quantity,
      tax_percentage: _.toNumber(props.percentage),
      tax_use_percentage: props.use_percentage,
      merchant_fee,
      fee_type: feeTypeExclude ? 'ExcludeFee' : 'IncludeFee',
      is_set_sale_time,
      sale_begin_time_utc,
      sale_end_time_utc,
      is_need_code_to_show,
      is_hide_ticket_level_from_pos,
      is_mark_ticket_level_as_sold_out,
      show_is_sould_out_ticket_id,
      is_show_ticket_description,
      is_show_long_ticket_description,
      is_add_ticket_custom_confirmation,
      is_customize_ticket_quantity_options,
      is_customize_ticket_taxes_and_fees
    };
      onHandleControlTicketData(_tickets);
  },
    [
    short_description,
    description,
    specific_message,
    order_min_quantity,
    order_max_quantity,
    default_ticket_quantity,
    merchant_fee,
    feeTypeExclude,
    is_set_sale_time,
    sale_begin_time_utc,
    sale_end_time_utc,
    is_need_code_to_show,
    is_hide_ticket_level_from_pos,
    is_mark_ticket_level_as_sold_out,
    show_is_sould_out_ticket_id,
    is_show_ticket_description,
    is_show_long_ticket_description,
    is_add_ticket_custom_confirmation,
    is_customize_ticket_quantity_options,
    is_customize_ticket_taxes_and_fees
  ]);

  const jsCTooltipRefTaxFee = React.createRef();
  const jsCTooltipRefYourFee = React.createRef();
  const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  const [isShowLimitWarning, toggleShowLimitWarning] = React.useState(false);

  // TODO
  const vMsgRef = React.useRef(null);
  const [isShowLimitLabel2, toggleShowLimitLabel2] = React.useState(false);
  const [isShowLimitWarning2, toggleShowLimitWarning2] = React.useState(false);

  const _limit = 7500;

  const resetPastedTextStyles = (e: any) => {
    const clipboardData = ((e.originalEvent || e).clipboardData || window.clipboardData);
    const bufferText = clipboardData.getData('Text');
    const bufferHtml = clipboardData.getData('text/html');

    if (bufferHtml.indexOf('SparxoCopy') > -1) {
      // allow html markup
    } else {
    const p = bufferText.split('\n');

    let text = '';

       for (let i = 0; i < p.length; i++) {
           const s = $('<p></p>').text(p[i]).html();

           text += `<p>${s}</p>`;
       }

       if (text !== '') {
           document.execCommand('insertHTML', false, text);
       }
       e.preventDefault();
      }
  };

  return (
    <div className='EventDetailsTicketAdvSet'>
      <div className="row">
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Show_short_ticket_description-${index}`}
            index={0}
            checked={is_show_ticket_description}
            onCallback={() => {
              ShowTicketDescr(!is_show_ticket_description);
            }}
            label='Show short ticket description'
          />
          {is_show_ticket_description &&
            <SimpleInput
              name='short_description'
              id={`Show_short_ticket_description-switcher-${index}`}
              label='Short ticket description'
              style={{
                marginLeft: '3.25rem'
              }}
              value={short_description}
              onChange={(e: any) => {
                _setShortDescription(e.target.value);
              }}
              maxLength={512}
              isShowLimit
              limit={512}
              limitCb={setValidateDataLength}
            />
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Show_long_ticket_description-s-${index}`}
            index={1}
            checked={is_show_long_ticket_description}
            onCallback={() => {
              ShowLongTicketDescr(!is_show_long_ticket_description);
            }}
            label='Show long ticket description'
          />
          {is_show_long_ticket_description &&
            <div
              className="form-group SimpleInput"
              style={{
                marginLeft: '3.25rem',
                width: 'calc(100% - 3.25rem)',
                position: 'relative'
              }}
            >
              <label htmlFor={`Show_long_ticket_description-t-${index}`}>Long ticket description</label>
              <textarea
                style={{
                  resize: 'vertical'
                }}
                className={`form-control ${isShowLimitWarning ? 'validationElement' : ''}`}
                name='description'
                id={`Show_long_ticket_description-t-${index}`}
                rows="5"
                value={description}
                onChange={(e: any) => {
                  _setLong_description(e.target.value);

                  toggleShowLimitWarning(_.size(e.target.value) > 512);
                }}
                onFocus={() => {
                  toggleShowLimitLabel(true);
                }}
                onBlur={() => {
                  toggleShowLimitLabel(false);
                }}
              />
              {isShowLimitLabel &&
                <span
                  className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-addons'
                  style={{
                    top: '25px'
                  }}
                >
                  {_.size(description)}/{512}
                </span>
              }
              {isShowLimitWarning &&
                <span
                  style={{
                    color: 'red'
                  }}
                >Please enter no more than {512} characters.</span>
              }
            </div>
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-6 form-switcher-custom-msg">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Show_long_ticket_description-s2-${index}`}
            index={2}
            checked={is_add_ticket_custom_confirmation}
            onCallback={() => {
              ShowConfigMsg(!is_add_ticket_custom_confirmation);
            }}
            label='Add custom confirmation message specific to the purchase of this ticket level'
          />

          {is_add_ticket_custom_confirmation &&
            <div
              className="form-group SimpleInput ReactSummernote"
              style={{
                marginLeft: '3.25rem'
                // width: 'calc(100% - 3.25rem)'
              }}
            >
              <label htmlFor='Custom_confirmation_message'>Custom confirmation message</label>
              <React.Suspense>
                {navigator ?
                  <div
                    className={`js-anchor-custom_confirmation_message ${isShowLimitWarning2 ? 'validationElement' : ''}`}
                    style={{
                      position: 'relative'
                    }}
                  >
                    <ReactSummernote
                      children={<div dangerouslySetInnerHTML={{ __html: specific_message }} />}
                      options={{
                        lang: 'en-US',
                        height: SummenrNoteToolbarHeight10Lines,
                        dialogsInBody: true,
                        toolbar: SummenrNoteToolbar
                      }}
                      onInit={() => {
                        setTimeout(() => {
                          // eslint-disable-next-line
                          const resizebleEl = document.querySelector('.js-anchor-custom_confirmation_message .note-editable.panel-body');

                          if (resizebleEl) {
                            resizebleEl.style.resize = 'vertical';
                          }
                        }, 1000);
                      }}
                      onPaste={(e): void => resetPastedTextStyles(e)}
                      onChange={(data: string) => {
                        handleChangeMCE(data);

                        const _isShowLimitWarning2 = getWordsCount(data) - 11 > _limit;

                        toggleShowLimitWarning2(_isShowLimitWarning2);
                        vMsgRef.current.style.display = _isShowLimitWarning2 ? 'block' : 'none';

                        if (_isShowLimitWarning2) {
                          props.setValidateDataLength('js-anchor-custom_confirmation_message');
                        } else {
                          props.setValidateDataLength('js-anchor-custom_confirmation_message', 1);
                        }
                      }}
                      onFocus={() => {
                        toggleShowLimitLabel2(true);
                      }}
                      onBlur={() => {
                        toggleShowLimitLabel2(false);
                      }}
                    />

                    {isShowLimitLabel2 &&
                      <span className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-summernote'>
                       {getWordsCount(specific_message)}/{_limit}
                      </span>
                    }
                    <div
                      className='ReactSummernote-vMsg vMsg'
                      ref={vMsgRef}
                    >
                      {isShowLimitWarning2 ?
                        `Please enter no more than ${_limit} characters.` :
                        'This field is required.'
                      }
                    </div>
                  </div> : null
                }
              </React.Suspense>
            </div>
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Customize_ticket_quantity_options-${index}`}
            index={3}
            checked={is_customize_ticket_quantity_options}
            onCallback={() => {
              ShowTicketQuantity(!is_customize_ticket_quantity_options);
            }}
            label='Customize ticket quantity options'
          />

          {is_customize_ticket_quantity_options &&
          <div
            className="form-group SimpleInput"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gridColumnGap: '1rem',
              alignItems: 'baseline'
            }}
          >
            <SimpleInput
              name='default_ticket_quantity'
              id={`Default_tickets_selected-${index}`}
              label='Default tickets selected'
              value={_.toString(default_ticket_quantity)}
              onChange={(e: any) => {
                const _value = e.target.value;

                let value = !_.size(_.toString(_value)) ? '0' : _value;

                if (value === '0') {
                  document.querySelector(`[id="Default_tickets_selected-${index}"]`).select();
                }

                if (_.size(value) > 1 && value[0] === '0') {
                  value = value.substring(1);
                }

                _setDefaultTicketQuantity(value);
              }}
              validator={((+default_ticket_quantity > +order_max_quantity) || (+default_ticket_quantity < +order_min_quantity)) && +default_ticket_quantity !== 0
                ?
                {
                  text: ((+default_ticket_quantity > +order_max_quantity)) && +default_ticket_quantity !== 0 ?
                    `The total number of default tickets can not be more than ${order_max_quantity}. This is to minimize the risk of fraud.` :
                    'Default Ticket Quantity can not be less than minimum quantity, unless set to 0'
                } :
                false
              }
              forceShowValidator={((+default_ticket_quantity > +order_max_quantity) || (+default_ticket_quantity < +order_min_quantity)) && +default_ticket_quantity !== 0}
              type='number'
            />
            <SimpleInput
              name='order_min_quantity'
              id={`Minimum_tickets_required-${index}`}
              label='Minimum tickets (required)'
              value={_.toString(order_min_quantity)}
              onChange={(e: any) => {
                const _value = e.target.value;

                let  value = !_.size(_.toString(_value)) ? '0' : _value;

                if (value === '0') {
                  document.querySelector(`[id="Minimum_tickets_required-${index}"]`).select();
                }

                if (_.size(value) > 1 && value[0] === '0') {
                  value = value.substring(1);
                }

                _setOrderMinQuantity(value);
              }}
              type='number'
              style={{
                paddingTop: '15px'
              }}
              validator={
                ((+order_min_quantity > +default_ticket_quantity) && +default_ticket_quantity !== 0) || +order_min_quantity > +order_max_quantity ?
                  { text: `Please enter a value less than or equal to ${order_max_quantity > default_ticket_quantity ? order_max_quantity : default_ticket_quantity} and more or equal to ${default_ticket_quantity}.` }
                  :
                  false
              }
              forceShowValidator={+order_min_quantity > +default_ticket_quantity || +order_min_quantity > +order_max_quantity}
            />
            <SimpleInput
              name='order_max_quantity'
              id={`Maximum_tickets_required-${index}`}
              label='Maximum tickets (required)'
              value={_.toString(order_max_quantity)}
              onChange={(e: any) => {
                const _value = e.target.value;

                let value = !_.size(_.toString(_value)) ? '0' : _value;

                if (value === '0') {
                  document.querySelector(`[id="Maximum_tickets_required-${index}"]`).select();
                }

                if (_.size(value) > 1 && value[0] === '0') {
                  value = value.substring(1);
                }

                _setOrderMaxQuantity(value);
              }}
              type='number'
            />
          </div>
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Customize_Taxes_and_Fees-${index}`}
            index={4}
            checked={is_customize_ticket_taxes_and_fees}
            onCallback={() => {
              ShowTaxes(!is_customize_ticket_taxes_and_fees);
            }}
            label='Customize Taxes and Fees'
          />

          {is_customize_ticket_taxes_and_fees &&
          <>
            <div className='customize-taxFee-container'>
                <label
                  htmlFor={`tax_fee-${ticketId}`}
                  style={{
                    fontWeight: 'normal'
                  }}
                >
                  Tax Fee
                </label>
                <div className="input-group form-group SimpleInput">
                  <div className="input-group-btn">
                    <button
                      type="button"
                      className="btn btn-default dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{
                        borderColor: 'transparent',
                        background: '#eeeeee',
                        width: '56px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <span>{props.use_percentage ? '%' : currency[context.profileCurrent.currency]}</span>
                      <span className="caret" />
                    </button>
                    <ul className="dropdown-menu Percentage_drop">
                      <li
                        onClick={() => {
                          __setUsePercantage(true);
                        }}
                      ><span>%</span></li>
                      <li
                        onClick={() => {
                          __setUsePercantage(false);
                        }}
                      >
                        <span>{currency[context.profileCurrent.currency]}</span>
                      </li>
                    </ul>
                  </div>

                  <FeeTooltip
                    ticket={{
                      ...props.ticket,
                      tax: props.tax,
                      merchant_fee
                    }}
                    jsCTooltipRef={jsCTooltipRefTaxFee}
                    merchant_fee={merchant_fee}
                    tax={props.tax}
                    feeTypeExclude={feeTypeExclude}
                    price={props.price}
                  >
                    <SimpleInput
                      id={`tax_fee-${ticketId}`}
                      type="number"
                      className="form-control"
                      name={`tax_fee-${ticketId}`}
                      value={props.use_percentage ? _.toString(props.percentage) : _.toString(props.moneyTax / 100)}
                      onChange={(e: any) => {
                        if (props.use_percentage) {
                          props.__setPercantage(e.target.value);
                        } else {
                          props.__setMoneyTax(e.target.value * 100);
                        }
                      }}
                      onFocus={() => {
                        jsCTooltipRefTaxFee.current.classList.add('isLocked');
                      }}
                      onBlur={() => {
                        jsCTooltipRefTaxFee.current.classList.remove('isLocked');
                      }}
                    />
                </FeeTooltip>
                </div>
              <div className="input-group form-group SimpleInput">
                <FeeTooltip
                  ticket={{
                    ...props.ticket,
                    tax: props.tax,
                    merchant_fee
                  }}
                  jsCTooltipRef={jsCTooltipRefYourFee}
                  merchant_fee={merchant_fee}
                  tax={props.tax}
                  price={props.price}
                  feeTypeExclude={feeTypeExclude}
                >
                  <SimpleInput
                    name='merchant_fee'
                    id={`Your_fee-${index}`}
                    label='Your Fee'
                    withAddon={currency[context.profileCurrent.currency]}
                    addonPosition='start'
                    value={_.toString(merchant_fee / 100)}
                    onChange={(e: any) => {
                      _setMerchant_fee(e.target.value * 100);
                      props.__setMerchantFee(e.target.value * 100);
                    }}
                    type='number'
                    onFocus={() => {
                      jsCTooltipRefYourFee.current.classList.add('isLocked');
                    }}
                    onBlur={() => {
                      jsCTooltipRefYourFee.current.classList.remove('isLocked');
                    }}
                    style={{
                      position: 'relative',
                      zIndex: '0',
                      width: '238px'
                    }}
                  />
                </FeeTooltip>
              </div>
            </div>

            <div className="form-group" style={{ marginLeft: '3.25rem' }}>
              <label className="icheckbox">
                <input
                  type="checkbox"
                  onChange={(e: any) => {
                    setFeeType(e.target.checked);
                  }}
                  checked={feeTypeExclude}
                />
                <i className="icheckbox-icon" />
                <span>Pass fees on to customer</span>
              </label>
            </div>
          </>
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-7">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Set_tickets_sales_time-${index}`}
            index={5}
            checked={is_set_sale_time}
            onCallback={(e: any) => {
              _setIsSetSaleTime(e.target.checked);
            }}
            label='Set tickets sales time'
          />

          {is_set_sale_time &&
            <TicketDates
              index={index}
              sale_begin_time_utc={sale_begin_time_utc}
              sale_end_time_utc={sale_end_time_utc}
              onChange={handleChangeDate}
            />
          }
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Hide_ticket_level_from_check-out_flow-${index}`}
            index={5}
            checked={is_need_code_to_show}
            onCallback={(e: any) => {
              _setIsNeedCodeToShow(e.target.checked);
            }}
            label='Hide ticket level from check-out flow'
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Hide_ticket_level_from_POS-${index}`}
            index={5}
            checked={is_hide_ticket_level_from_pos}
            onCallback={() => {
              _setIs_hide_ticket_level_from_pos(!is_hide_ticket_level_from_pos);
            }}
            label='Hide ticket level from POS'
          />
        </div>
      </div>

      <div className="row" style={{ display: 'none' }}> //TODO: now hidden
        <div className="col-md-8 col-lg-6">
          <Switcher
            className='form-switcher-sm pull-left mb1rem'
            id={`Mark_ticket_level_as_sold_out-${index}`}
            index={5}
            checked={is_mark_ticket_level_as_sold_out}
            onCallback={() => {
              _setIs_mark_ticket_level_as_sold_out(!is_mark_ticket_level_as_sold_out);
            }}
            label='Mark ticket level as sold out'
          />
        </div>
      </div>

       <div className="row" style={{ display: 'none' }}> //TODO: now hidden
        <div className="col-md-8 col-lg-6">
          <Switcher
            disabled={_.size(tickets) === 1}
            className='form-switcher-sm pull-left mb1rem'
            id={`Show_ticket_only_after_another_ticket_level_is_sold_out-${index}`}
            index={5}
            checked={show_is_sould_out_ticket_id_switcher}
            onCallback={() => {
              _setShow_is_sould_out_ticket_id_switcher(!show_is_sould_out_ticket_id_switcher);
            }}
            label='Show ticket only after another ticket level is sold out'
          />

          {!!show_is_sould_out_ticket_id_switcher && _.size(tickets) > 1 &&
            <div className="form-group SimpleInput timezoneSelect" style={{ marginLeft: '3.25rem' }}>
              <label htmlFor="timeZone">Ticket Level</label>

              <SimpleSelect
                // validator={{}}
                items={_.map(tickets, (t: {}): {} => {
                  if (t.id && t.temp_id !== tickets[singleTicketObjIndex]) {
                    return {
                      value: t.id,
                      label: t.name
                    };
                  }
                })}
                value={show_is_sould_out_ticket_id || 0}
                callBack={(e: any) => {
                  _setShow_is_sould_out_ticket_id(e.target.value);
                }}
              />
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default EventDetailsTicketAdvSet;
